import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import Lottie from "react-lottie-player";
import lottieJson from "./success.json";
import lottieJson1 from "./success1.json";
import { checkMyDietPlan } from "../../../helper/mobile";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../../context/app-context";

const DietPlanAnalyzing = () => {
  const [state] = useContext(AppContext);
  const [onSuccessText, setOnSuccessText] = useState();
  let navigate = useNavigate();
  const { dietPlanId } = useParams();
  const timing = dietPlanId === "ai" ? 7000 : 2500;
  const user = state.user;


  useEffect(() => {
    let timer = setTimeout(() => {
      setOnSuccessText(true);
    }, timing);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    if (onSuccessText) {
      setTimeout(() => {
        if (dietPlanId === "ai") {
          checkMyDietPlan();
        } else {
          const dietPlanURL = `/dietPlan/?token=${user.token}&appVersion=${user.appVersion}&appVersionCode=${user.appVersionCode}&osType=${user.osType}`;
          navigate(dietPlanURL);
        }
      }, 500);
    }
  }, [onSuccessText]);

  return (
    <Container>
      <Row className="min-vh-90 justify-content-center align-items-center text-center">
        <Col>
          <Lottie
            loop={false}
            animationData={dietPlanId === "ai" ? lottieJson : lottieJson1}
            play
            style={{ height: 130 }}
            className="success-lottie"
          />
          <h3 className="mt-3 mb-3 analyzing-title">
            {onSuccessText ? "We are all set!1" : "Analyzing..."}
          </h3>
          {dietPlanId === "ai" && !onSuccessText && (
            <p className="success-p">
              Sit back and relax. We are recommending the best suited diet plan
              based on your answer
            </p>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default DietPlanAnalyzing;
